import {
  TOGGLE_LEAD_MODAL,
  TOGGLE_LEAD_MODAL_ALERT,
  TOGGLE_TASK_MODAL,
  SET_TASK_MODAL_ERRORS,
  TOGGLE_ALERT,
  TOGGLE_ALL_FILTERS_MODAL
} from '../actions/ui';

export default function(state = {}, action) {
  switch (action.type) {
  case TOGGLE_LEAD_MODAL:
    return { showModal: action.showModal, lead: action.lead };
  case TOGGLE_LEAD_MODAL_ALERT:
    return { ...state, showModalAlert: action.showAlert, errorMessage: action.errorMessage };
  case TOGGLE_TASK_MODAL:
    return {
      ...state, showTaskModal: action.showTaskModal, lead: action.lead, isLogged: action.isLogged, taskModalErrors: null
    };
  case SET_TASK_MODAL_ERRORS:
    return { ...state, taskModalErrors: action.errors };
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case TOGGLE_ALL_FILTERS_MODAL:
    return { ...state, showAllFiltersModal: !state.showAllFiltersModal };
  default:
    return state;
  }
}
